module.exports = __webpack_public_path__ + "static/media/transferFunds.264eb994.svg";